module.exports = __webpack_public_path__ + "img/BlendBuff-MgcCard.bdc14749.png";